import React from 'react'
import { PositionsTableHeader } from './PositionsTableHeader'
import { PositionRow } from './PositionRow'

export const UserPositionsTable = ({ positions }) => {

  const positionsRender = positions.map((position) => (
    <PositionRow key={position.id} data={position}/>
  ))

  return (
    <div>
      <PositionsTableHeader />
      {positionsRender}
    </div>
  )
}
